<template>
  <Headers> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <PogressBarStep :cardName="prop.cardName" :currentStep="6">
    </PogressBarStep>
    <Form
      @submit="onSubmit"
      :validation-schema="schema"
      @invalid-submit="onInvalidSubmit"
    >
      <div :class="[deviceType, 'inner']">
        <div :class="[deviceType, 'content']">
          <div :class="[deviceType, 'separator']">
            <div v-if="prop.idType == '1'" class="radio">
              <p class="description">
                {{ t("ccOnBoarding.employmentDetails.question") }}
              </p>
              <div class="agree">
                <section class="radioClass">
                  <RadioButton
                    v-for="option in hrcQuestionnaireEnum"
                    :key="option.value"
                    :label="option.label"
                    :values="option.value"
                    class="radioHorizontal"
                    field="homeProgram"
                    id="q1"
                    :selected-value="employmentDetails.question1"
                    :label-class="'radioLabel'"
                    @selected="question1Selection"
                    :class="{ 'display-flex': true }"
                  />
                </section>
              </div>
              <pre class="help" v-if="!errorMessage"> {{ errorMessage }}</pre>
              <pre class="help" v-else-if="error && errorMessage">{{
                errorMessage
              }}</pre>
              <pre class="help" v-else>&nbsp</pre>
            </div>
            <div
              v-if="
                (prop.idType == '1' && prop.pensioneer != '20') ||
                (prop.idType != '1' && prop.pensioneer != '20')
              "
            >
              <p class="description">
                {{ t("ccOnBoarding.employmentDetails.question2") }}
              </p>
              <div class="agree">
                <section class="radioClass">
                  <RadioButton
                    v-for="option in workplaceList"
                    :key="option.label"
                    :label="option.label"
                    :values="option.code"
                    class="radioHorizontal"
                    field="workMy"
                    id="q2"
                    :selected-value="employmentDetails.question2"
                    :label-class="'radioLabel'"
                    @selected="question2Selection"
                    :class="{ 'display-flex': true }"
                    :backend="true"
                    :disabled="
                      prop.idType == '1' && employmentDetails.question1 == 'Yes'
                    "
                    :default="
                      prop.idType == '1' && employmentDetails.question1 == 'Yes'
                        ? true
                        : false
                    "
                    :default-value="
                      prop.idType == '1' && employmentDetails.question1 == 'Yes'
                        ? 'Yes'
                        : ''
                    "
                  />
                </section>
              </div>
              <pre class="help" v-if="!errorMessage2"> {{ errorMessage2 }}</pre>
              <pre class="help" v-else-if="error2 && errorMessage2">{{
                errorMessage2
              }}</pre>
              <pre class="help" v-else>&nbsp</pre>
              <div class="part2">
                <div :class="[deviceType, 'container']">
                  <div :class="[deviceType, 'flex_half']">
                    <DropDown
                      v-model="employmentDetails.occupation"
                      :selectedOption="employmentDetails.occupation"
                      :options="occupationList"
                      :value="occupationList"
                      field="occupationType"
                      :placeholder="
                        t('ccOnBoarding.employmentDetails.occupationType')
                      "
                      :disabled="prop.employmentDetails.question2 == 'No'"
                      :default-value="defaultOccupation"
                      :fieldName="'occupationType'"
                    />
                  </div>

                  <div :class="[deviceType, 'flex_half']">
                    <DropDown
                      v-model="employmentDetails.employment"
                      :selectedOption="employmentDetails.employment"
                      :options="
                        employmentDetails.occupation == '0'
                          ? employmentEmployedList
                          : employmentSelfEmployedList
                      "
                      :value="
                        employmentDetails.occupation == '0'
                          ? employmentEmployedList
                          : employmentSelfEmployedList
                      "
                      :clear="isClear"
                      field="emplomentType"
                      :placeholder="
                        t('ccOnBoarding.employmentDetails.emplomentType')
                      "
                      :disabled="employmentDetails.occupation == ''"
                    />
                  </div>
                </div>
                <div :class="[deviceType, 'container']">
                  <div
                    v-if="employmentDetails.occupation == '0'"
                    :class="[deviceType, 'flex_half']"
                  >
                    <DropDown
                      v-model="employmentDetails.employmentIncome"
                      :selectedOption="employmentDetails.employmentIncome"
                      :options="employmentIncomeList"
                      :value="employmentIncomeList"
                      field="employmentIncome"
                      :placeholder="
                        t('ccOnBoarding.employmentDetails.employmentIncome')
                      "
                    />
                  </div>
                  <div
                    v-if="
                      employmentDetails.occupation == '0' ||
                      employmentDetails.occupation == '1'
                    "
                    :class="[deviceType, 'flex_half']"
                  >
                    <InputText
                      class="inputcomponent"
                      v-model="employmentDetails.companyName"
                      field="companyName"
                      :required="false"
                      :placeholder="
                        t('ccOnBoarding.employmentDetails.companyName')
                      "
                      :max-length="50"
                      :autocomplete="'new-password'"
                    />
                  </div>
                  <div v-else :class="[deviceType, 'flex_full']">
                    <InputText
                      class="inputcomponent"
                      v-model="employmentDetails.companyName"
                      field="companyName"
                      :required="false"
                      :placeholder="
                        t('ccOnBoarding.employmentDetails.companyName')
                      "
                      :max-length="50"
                      :autocomplete="'new-password'"
                    />
                  </div>
                  <div
                    v-if="employmentDetails.occupation == '1'"
                    :class="[deviceType, 'flex_half']"
                  >
                    <InputText
                      class="inputcomponent"
                      v-model="employmentDetails.sstRegistrationNo"
                      field="sstRegistrationNo"
                      :required="false"
                      :placeholder="
                        t('ccOnBoarding.employmentDetails.sstRegistrationNo')
                      "
                      :max-length="15"
                      :autocomplete="'new-password'"
                      @keydown="handleKeyDown"
                      @keydown.enter.prevent="handleEnterKey"
                    />
                  </div>
                </div>
              </div>
              <div :class="[deviceType, 'separator']">
                <div :class="[deviceType, 'container']">
                  <div :class="[deviceType, 'flex_half']">
                    <InputText
                      class="inputcomponent"
                      v-model="employmentDetails.companyAddress1"
                      field="companyAddressLine1"
                      :required="false"
                      :placeholder="
                        t('ccOnBoarding.employmentDetails.companyAddressLine1')
                      "
                      :max-length="50"
                      :autocomplete="'new-password'"
                    />
                  </div>
                  <div :class="[deviceType, 'flex_half']">
                    <InputText
                      class="inputcomponent"
                      v-model="employmentDetails.companyAddress2"
                      field="companyAddressLine2"
                      :required="false"
                      :placeholder="
                        t('ccOnBoarding.employmentDetails.companyAddressLine2')
                      "
                      :max-length="50"
                      :autocomplete="'new-password'"
                    />
                  </div>
                </div>
                <div :class="[deviceType, 'container']">
                  <div
                    v-if="prop.employmentDetails.question2 == 'Yes'"
                    :class="[deviceType, 'flex_half']"
                  >
                    <InputText
                      class="inputcomponent"
                      v-model="employmentDetails.companyAddress3"
                      field="companyAddressLine3"
                      :required="false"
                      :placeholder="
                        t('ccOnBoarding.employmentDetails.companyAddressLine3')
                      "
                      :max-length="50"
                      :autocomplete="'new-password'"
                    />
                  </div>
                  <div v-else :class="[deviceType, 'flex_full']">
                    <InputText
                      class="inputcomponent"
                      v-model="employmentDetails.companyAddress3"
                      field="companyAddressLine3"
                      :required="false"
                      :placeholder="
                        t('ccOnBoarding.employmentDetails.companyAddressLine3')
                      "
                      :max-length="50"
                      :autocomplete="'new-password'"
                    />
                  </div>

                  <div
                    v-if="prop.employmentDetails.question2 == 'Yes'"
                    :class="[deviceType, 'flex_half']"
                  >
                    <InputText
                      v-bind="$attrs"
                      class="inputcomponent"
                      v-model="employmentDetails.postCode"
                      field="postCode"
                      :postCode="true"
                      :required="false"
                      :placeholder="
                        t('ccOnBoarding.employmentDetails.postCode')
                      "
                      :max-length="5"
                      :autocomplete="'new-password'"
                      onkeypress="
                        return event.charCode >= 48 && event.charCode <= 57;
                      "
                      :number="'true'"
                      :type="'text'"
                      :inputmode="'numeric'"
                      :pattern="'[0-9]*'"
                    />
                  </div>
                </div>
                <div
                  v-if="prop.employmentDetails.question2 == 'Yes'"
                  :class="[deviceType, 'container']"
                >
                  <div :class="[deviceType, 'flex_half']">
                    <InputText
                      :disabled="true"
                      class="inputcomponent"
                      v-model="employmentDetails.city"
                      :value="employmentDetails.city"
                      field="city"
                      :required="false"
                      :placeholder="t('ccOnBoarding.employmentDetails.city')"
                      :autocomplete="'new-password'"
                    />
                  </div>

                  <div :class="[deviceType, 'flex_half']">
                    <InputText
                      class="inputcomponent"
                      :disabled="true"
                      v-model="employmentDetails.state"
                      :value="employmentDetails.state"
                      field="state"
                      :required="false"
                      :placeholder="t('ccOnBoarding.employmentDetails.state')"
                      :max-length="21"
                      :autocomplete="'new-password'"
                    />
                  </div>
                </div>
              </div>
              <div :class="[deviceType, 'separator']">
                <div :class="[deviceType, 'container']">
                  <div :class="[deviceType, 'flex_half']">
                    <div :class="[deviceType, 'container2']">
                      <div :class="[deviceType, 'flex_third']">
                        <DropDown
                          v-if="deviceType == 'Mobile'"
                          v-model="employmentDetails.countryCode"
                          :selectedOption="employmentDetails.countryCode"
                          :options="mobileCountryCodeList"
                          :value="mobileCountryCodeList"
                          :default="true"
                          :default-value="'60'"
                          field="countryCode"
                          :placeholder="''"
                          :is-country-code="true"
                        />
                        <DropDown
                          v-else
                          v-model="employmentDetails.countryCode"
                          :selectedOption="employmentDetails.countryCode"
                          :options="mobileCountryCodeList"
                          :value="mobileCountryCodeList"
                          :default="true"
                          :default-value="'60'"
                          field="countryCode"
                          :placeholder="
                            t('ccOnBoarding.employmentDetails.countryCode')
                          "
                        />
                      </div>
                      <div :class="[deviceType, 'flex_half', 'mobile2']">
                        <InputText
                          class="inputcomponent"
                          v-model="employmentDetails.areaCode"
                          field="areaCode"
                          :required="false"
                          :placeholder="
                            t('ccOnBoarding.employmentDetails.areaCode')
                          "
                          :max-length="2"
                          :min-length="2"
                          :autocomplete="'new-password'"
                          onkeypress="
                            return event.charCode >= 48 && event.charCode <= 57;
                          "
                          :number="'true'"
                          :type="'text'"
                          :pattern="'[0-9]*'"
                          :inputmode="'numeric'"
                          :trimZero="true"
                        />
                      </div>
                    </div>
                  </div>
                  <div :class="[deviceType, 'flex_half']">
                    <InputText
                      class="inputcomponent"
                      v-model="employmentDetails.phoneNo"
                      field="companyPhoneNumber"
                      :required="false"
                      :placeholder="
                        t('ccOnBoarding.employmentDetails.companyPhoneNumber')
                      "
                      :max-length="8"
                      :min-length="6"
                      :autocomplete="'new-password'"
                      onkeypress="
                        return event.charCode >= 48 && event.charCode <= 57;
                      "
                      :number="'true'"
                      :type="'text'"
                      :pattern="'[0-9]*'"
                      :inputmode="'numeric'"
                    />
                  </div>
                </div>

                <div :class="[deviceType, 'container']">
                  <div :class="[deviceType, 'flex_full']">
                    <DropDown
                      v-model="employmentDetails.natureBusiness"
                      :selectedOption="employmentDetails.natureBusiness"
                      :options="natureOfBusinessList"
                      :value="natureOfBusinessList"
                      field="nob"
                      :placeholder="
                        t('ccOnBoarding.employmentDetails.natureOfBusiness')
                      "
                    />
                  </div>
                  <div
                    :class="[deviceType, 'flex_full']"
                    v-if="employmentDetails.natureBusiness == '90'"
                  >
                    <InputText
                      class="inputcomponent"
                      v-model="employmentDetails.others"
                      :value="employmentDetails.others"
                      field="natureOfBusinessOthers"
                      :required="false"
                      :placeholder="t('ccOnBoarding.employmentDetails.others')"
                      :max-length="50"
                      :autocomplete="'new-password'"
                    />
                  </div>
                </div>
                <div :class="[deviceType, 'container']">
                  <div :class="[deviceType, 'flex_full']">
                    <div :class="[deviceType, 'margin']">
                      <InputText
                        class="inputcomponent"
                        v-model="employmentDetails.yearEmp"
                        field="yearEmp"
                        :required="false"
                        :placeholder="
                          t('ccOnBoarding.employmentDetails.yearEmp')
                        "
                        :max-length="2"
                        :autocomplete="'new-password'"
                        :type="'text'"
                        :inputmode="'numeric'"
                        :number="'true'"
                        :trim="true"
                        onkeypress="
                          return event.charCode >= 48 && event.charCode <= 57;
                        "
                        @keydown.enter.prevent="handleEnterKey"
                      />
                    </div>
                  </div>

                  <div :class="[deviceType, 'flex_full']">
                    <DropDown
                      v-model="employmentDetails.monthEmp"
                      :selectedOption="employmentDetails.monthEmp"
                      :options="lengthofEmplymentList"
                      :value="lengthofEmplymentList"
                      field="monthEmp"
                      :placeholder="
                        t('ccOnBoarding.employmentDetails.monthEmp')
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div :class="[deviceType, 'buttoncontainer']">
            <button
              v-if="prop.summarySetting.employmentDetailsJump == false"
              :class="[deviceType, 'left-button']"
              type="button"
              @click="handleBack"
            >
              {{ t("ccOnBoarding.back") }}
            </button>
            <div v-else :class="[deviceType, 'left-button:disabled']"></div>
            <button
              v-if="prop.summarySetting.employmentDetailsJump == false"
              :disabled="isBtnDisabled"
              :class="[deviceType, 'right-button']"
            >
              {{ t("ccOnBoarding.next") }}
            </button>
            <button
              v-else
              :class="[deviceType, 'summary-button']"
              :disabled="isBtnDisabled"
            >
              {{ t("ccOnBoarding.backToSummary") }}
            </button>
          </div>
        </div>
      </div>
    </Form>
  </div>
  <div v-if="prop.overlay" class="overlay">
    <div class="text-center flex-container">
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
        <!-- <b>Submit Fail</b> -->
      </p>
      <br />
      <div class="spinner-border" role="status">
        <span class="sr-only">{{
          t("ccOnBoarding.uploadDocument.loading2")
        }}</span>
      </div>
      <br />
      <br />
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
      </p>
      <br />
      <br />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  computed,
  watch,
  onBeforeMount,
  type PropType,
  onMounted,
} from "vue";
import Headers from "./components/Headers.vue";
import PogressBarStep from "./components/ProgressBarStep.vue";
import DropDown from "./components/NewDropDownComponent.vue";
import InputText from "./components/NewInputTextComponent.vue";
import i18n from "@/plugin/i18n";
import { Form } from "vee-validate";
import RadioButton from "./components/NewRadioButtonComponent.vue";
import hrcQuestionnaireEnum from "@/enum/HRCQuestionnaireEnum";
import { number0_11 } from "@/enum/Number";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import type { EmploymentDetails } from "@/interface/FormCC";
import { deviceDetect } from "mobile-device-detect";
import type { SummarySetting } from "@/interface/FormCC";

const deviceType = ref("");
const prop = defineProps({
  employmentDetails: {
    type: Object as PropType<EmploymentDetails>,
    required: true,
  },
  dob: {
    type: String,
    required: true,
  },
  overlay: {
    type: Boolean,
    required: true,
  },
  idType: {
    type: String,
    required: true,
  },
  pensioneer: {
    type: String,
    required: true,
  },
  cardName: {
    type: String,
    required: true,
  },
  summarySetting: {
    type: Object as PropType<SummarySetting>,
    required: true,
  },
  isAutoPopulate: {
    type: Boolean,
    default: false,
  },
  populatedIdInfo: {
    type: Object,
    required: true,
  },
  pfExpired: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
  },
});

const { t } = i18n.global;

const errorMessage = ref("");
const error = ref(true);
const errorMessage2 = ref("");
const error2 = ref(true);
const verifyLoE = ref();
const isClear = ref("false");

//Temp Checking
const dobParts = prop.dob.split("/");
const dobYear = parseInt(dobParts[2]);

interface Workplace {
  code: string;
  label: string;
}
//List
const occupationList = ref([]);
const employmentList = ref([]);
const employmentEmployedList = ref([]);
const employmentSelfEmployedList = ref([]);
const mobileCountryCodeList = ref([]);
const natureOfBusinessList = ref([]);
const lengthofEmplymentList = ref(number0_11);
const employmentIncomeList = ref([]);
const workplaceList = ref([] as Workplace[]);

let previousValue: string | null = null;

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

onBeforeMount(() => {
  MasterService.getMasterData()
    .then((res) => {
      occupationList.value = res.data.occupationType;
      employmentList.value = res.data.employeeType;
      employmentEmployedList.value = res.data.employmentTypeEmployed;
      employmentSelfEmployedList.value = res.data.employmentTypeSelfEmployed;
      mobileCountryCodeList.value = res.data.mobileNoCountryCode;
      natureOfBusinessList.value = res.data.natureOfBusinessType;
      employmentIncomeList.value = res.data.employmentIncomeType;
      // workplaceList.value = res.data.workplaceType;
      workplaceList.value = res.data.workplaceType.map(
        (item: { code: string; value: string }) => ({
          code: item.code,
          label: item.value,
        }),
      );
    })
    .catch((e) => {});
});

watch(
  () => prop.employmentDetails.occupation,
  (newValue) => {
    if (newValue) {
      isClear.value = previousValue === "0" ? "1" : "0";
      previousValue = isClear.value;
    }
  },
);

watch(
  () => prop.employmentDetails.postCode,
  (newValue) => {
    if (prop.isAutoPopulate && newValue) {
      prop.populatedIdInfo.employmentDetails.postcode =
        prop.employmentDetails.postCode;
    }
  },
);

watch(
  () => prop.employmentDetails.sstRegistrationNo,
  (newValue) => {
    if (prop.isAutoPopulate && newValue) {
      prop.populatedIdInfo.employmentDetails.sstRegistrationNo =
        prop.employmentDetails.sstRegistrationNo;
    }
  },
);

const getFilteredEmploymentList = computed(() => {
  if (prop.employmentDetails.occupation === "0") {
    // Display the first three elements
    return [
      employmentList.value[1],
      employmentList.value[2],
      employmentList.value[3],
    ];
  } else if (prop.employmentDetails.occupation === "1") {
    // Display the fourth to sixth elements
    return [
      employmentList.value[0],
      employmentList.value[5],
      employmentList.value[4],
    ];
  } else {
    return [];
  }
});

async function postCodeData() {
  if (prop.employmentDetails.postCode.length >= 5) {
    try {
      const res = await MasterService.checkPostCode(
        prop.employmentDetails.postCode
      );
      prop.employmentDetails.city = res.data.responseModel.city;
      prop.employmentDetails.state = res.data.responseModel.state;
      schema.value.postCode =
        "minLengthNumber:5|maxLengthNumber:5|requiredNumber|numberFormat";
    } catch (e) {
      prop.employmentDetails.city = "";
      prop.employmentDetails.state = "";
      schema.value.postCode =
        "minLengthNumber:5|maxLengthNumber:5|requiredNumber|invalidPostCode|numberFormat";
    }
  }
}

const getValue = computed(async () => {
  if (!(prop.idType == "1" && prop.pensioneer == "20")) {
    if (prop.employmentDetails.postCode.length < 5) {
      prop.employmentDetails.city = "";
      prop.employmentDetails.state = "";
    } else if (prop.employmentDetails.postCode.length >= 5) {
      await postCodeData();
    }

    return {
      city: prop.employmentDetails.city,
      state: prop.employmentDetails.state,
    };
  }
});

const cityValue = ref("");
const stateValue = ref("");

async function updateValues() {
  const newValues = await getValue.value;
  if (newValues) {
    cityValue.value = newValues.city;
    stateValue.value = newValues.state;
  }
}

watch(getValue, updateValues, { immediate: true });

const test = ref("");
const stopSchemaUpdate = ref(false);
const question1Selection = (option: string) => {
  prop.employmentDetails.question1 = option;
  error.value = false;
};

const question2Selection = (option: string) => {
  prop.employmentDetails.question2 = option;
  error2.value = false;
};

const schema = computed(() => {
  const question2 = prop.employmentDetails.question2 == "Yes";
  return {
    homeProgram: prop.idType == "1" ? "required" : "",
    workMy: prop.idType == "1" && prop.pensioneer == "20" ? "" : "required",
    occupationType:
      prop.idType == "1" && prop.pensioneer == "20" ? "" : "required",
    emplomentType:
      prop.idType == "1" && prop.pensioneer == "20" ? "" : "required",
    employmentIncome:
      prop.idType == "1" && prop.pensioneer == "20"
        ? ""
        : prop.employmentDetails.occupation == "0"
          ? "required"
          : "",
    companyName:
      prop.idType == "1" && prop.pensioneer == "20"
        ? ""
        : prop.pfExpired || prop.type == "CR_SL"
          ? "required"
          : "required|customFormat",
    sstRegistrationNo:
      prop.employmentDetails.sstRegistrationNo != "" ? "fixedLength:15" : "",
    companyAddressLine1:
      prop.idType == "1" && prop.pensioneer == "20" ? "" : "required",
    // companyAddressLine2:
    //   prop.idType == "1" && prop.pensioneer == "20" ? "" : "required",
    postCode:
      prop.idType == "1" && prop.pensioneer == "20"
        ? ""
        : question2
          ? "minLengthNumber:5|maxLengthNumber:5|requiredNumber|numberFormat"
          : "",
    countryCode:
      prop.idType == "1" && prop.pensioneer == "20" ? "" : "required",
    companyPhoneNumber:
      prop.idType == "1" && prop.pensioneer == "20"
        ? ""
        : prop.employmentDetails.countryCode == "60"
          ? prop.pfExpired || prop.type == "CR_SL"
            ? "requiredNumber|minLengthNumber:6|maxLengthNumber:10|numberFormat"
            : "requiredNumber|minLengthNumber:6|maxLengthNumber:8|numberFormat"
          : prop.employmentDetails.countryCode == "65"
            ? prop.pfExpired || prop.type == "CR_SL"
              ? "requiredNumber|minLengthNumber:6|maxLengthNumber:10|numberFormat"
              : "requiredNumber|minLengthNumber:6|maxLengthNumber:8|numberFormat"
            : prop.employmentDetails.countryCode == "673"
              ? prop.pfExpired || prop.type == "CR_SL"
                ? "requiredNumber|minLengthNumber:6|maxLengthNumber:10|numberFormat"
                : "requiredNumber|minLengthNumber:6|maxLengthNumber:8|numberFormat"
              : "",
    areaCode: prop.idType == "1" && prop.pensioneer == "20" ? "" : "required",
    nob: prop.idType == "1" && prop.pensioneer == "20" ? "" : "required",
    natureOfBusinessOthers: "",
    yearEmp:
      prop.idType == "1" && prop.pensioneer == "20"
        ? ""
        : `requiredNumber|maxValue_LoE:${verifyLoE.value}`,
    monthEmp:
      prop.idType == "1" && prop.pensioneer == "20" ? "" : "requiredNumber",
  };
});

const isBtnDisabled = computed(() => {
  const passportPensioneer = prop.idType == "1" && prop.pensioneer == "20";
  return (
    (prop.idType == "1" && prop.employmentDetails.question1.length == 0) ||
    (!passportPensioneer && prop.employmentDetails.question2.length == 0) ||
    (!passportPensioneer && prop.employmentDetails.occupation.length == 0) ||
    (!passportPensioneer && prop.employmentDetails.employment.length == 0) ||
    (!passportPensioneer &&
      prop.employmentDetails.occupation == "0" &&
      prop.employmentDetails.employmentIncome.length == 0) ||
    (!passportPensioneer && prop.employmentDetails.companyName.length == 0) ||
    (prop.employmentDetails.sstRegistrationNo != "" &&
      prop.employmentDetails.sstRegistrationNo.length != 15) ||
    (!passportPensioneer &&
      prop.employmentDetails.companyAddress1.length == 0) ||
    // (!passportPensioneer &&
    //   prop.employmentDetails.companyAddress2.length == 0) ||
    (!passportPensioneer &&
      prop.employmentDetails.question2 == "Yes" &&
      prop.employmentDetails.postCode.length == 0) ||
    (!passportPensioneer &&
      prop.employmentDetails.question2 == "Yes" &&
      prop.employmentDetails.city.length == 0) ||
    (!passportPensioneer && prop.employmentDetails.countryCode.length == 0) ||
    (!passportPensioneer && prop.employmentDetails.phoneNo.length == 0) ||
    (!passportPensioneer && prop.employmentDetails.areaCode.length == 0) ||
    (!passportPensioneer &&
      prop.employmentDetails.natureBusiness.length == 0) ||
    (!passportPensioneer && prop.employmentDetails.monthEmp.length == 0) ||
    (!passportPensioneer && prop.employmentDetails.yearEmp.length == 0)
  );
});

const onInvalidSubmit = () => {
  if (prop.employmentDetails.question1 == "") {
    errorMessage.value = t("ccOnBoarding.employmentDetails.error");
  }
};
// const handleSubmit = () => {
//   errorMessage2.value = t("ccOnBoarding.employmentDetails.error2");
//   const other = prop.employmentDetails.natureBusiness == "90";
//   schema.value.occupationType = "required";
//   schema.value.emplomentType = "required";
//   schema.value.employmentIncome = "required";
//   schema.value.companyName = "required|customFormat";
//   schema.value.companyAddressLine1 = "required";
//   schema.value.companyAddressLine2 = "required";
//   if (prop.employmentDetails.question2 == "Yes") {
//     schema.value.postCode =
//       "minLengthNumber:5|maxLengthNumber:5|requiredNumber|numberFormat";
//   }
//   schema.value.countryCode = "required";
//   schema.value.companyPhoneNumber =
//     "requiredNumber|minLengthNumber:8|maxLengthNumber:14|numberFormat";
//   schema.value.areaCode = "required";
//   schema.value.nob = "required";
//   schema.value.natureOfBusinessOthers = other ? "required" : "";
//   schema.value.yearEmp = `requiredNumber|maxValue_LoE:${verifyLoE.value}`;
//   schema.value.monthEmp = "requiredNumber";
// };

const emit = defineEmits(["nextStep", "previousStep", "submit"]);
const onSubmit = () => {
  emit("submit");
};

const handleBack = () => {
  emit("previousStep");
};

const defaultOccupation = computed(() => {
  return prop.employmentDetails.question2 == "No" ? "0" : "";
});

watch(
  () => prop.employmentDetails.question2,
  (newValue) => {
    if (newValue == "Yes" && prop.isAutoPopulate) {
      prop.employmentDetails.postCode =
        prop.populatedIdInfo.employmentDetails.postcode;
    } else if (newValue == "Yes") {
      prop.employmentDetails.occupation = "";
      prop.employmentDetails.postCode = "";
    }
  },
);

watch(
  () => prop.employmentDetails.question2,
  (newValue) => {
    if (newValue) {
      prop.employmentDetails.postCode = "";
      prop.employmentDetails.city = "";
      prop.employmentDetails.state = "";
    }
  },
);

watch(
  () => prop.employmentDetails.yearEmp,
  (newValue) => {
    if (newValue) {
      const currentYear = new Date().getFullYear();
      verifyLoE.value = currentYear - dobYear - 16;
    }
  },
);

watch(
  () => prop.employmentDetails.occupation,
  (newValue) => {
    if (newValue) {
      prop.employmentDetails.employmentIncome = "";
      if (newValue == "1" && prop.isAutoPopulate) {
        prop.employmentDetails.sstRegistrationNo =
          prop.populatedIdInfo.employmentDetails.sstRegistrationNo;
      } else {
        prop.employmentDetails.sstRegistrationNo = "";
      }
    }
  },
);

watch(
  () => prop.employmentDetails.natureBusiness,
  (newValue) => {
    if (newValue) {
      prop.employmentDetails.others = "";
    }
  },
);

watch(
  () => prop.employmentDetails.question1,
  (newValue) => {
    if (newValue) {
      prop.employmentDetails.question2 = "";
    }
  },
);

watch(
  [() => prop.idType, () => prop.employmentDetails.question1],
  ([value1, value2], [prevResend, prevNumber]) => {
    if (value1 == "1") {
      if (value2 == "Yes") {
        prop.employmentDetails.question2 = "Yes";
      } else if (value2 == "No") {
        prop.employmentDetails.question2 = "";
      }
    }
  },
);

const handleKeyDown = (event: KeyboardEvent) => {
  const isDigit = /^[0-9]$/.test(event.key);
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === " Tab";

  const isSymbol = /[^a-zA-Z0-9]/.test(event.key); // true for symbol input

  if (
    isSymbol &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey &&
    !isTabKey
  ) {
    event.preventDefault();
  }
};

const handleEnterKey = () => {};
</script>

<style scoped>
.progressContainer {
  max-width: 1440px;
  margin: auto;
  padding: 4% 8%;
  background: #fff;
}

.radioClass {
  display: flex;
  align-items: flex-end;
}

.content {
  margin-top: 40px;
  padding: 0 8%;
}

.container {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  margin-bottom: 14px;
}

.container2 {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  max-width: none;
}

.help {
  color: red;
  margin-bottom: 0px;
  font:
    400 16px/130% "Outfit",
    sans-serif;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.flex_half {
  width: 50%;
}
.flex_third {
  width: 50%;
}

.flex_full {
  width: 100%;
}

.separator {
  margin-bottom: 37px;
}

.content .separator:first-child {
  border-bottom: 1px solid #e4e4e4;
}

.flex_dropdown {
  display: flex;
  width: 30%;
  box-sizing: border-box;
  position: relative;
  display: inline-block;
}

.flex_inputText {
  width: 70%;
}
.part2 {
  margin-top: 20px;
}

.radio {
  margin-bottom: 15px;
}

.summary-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 100%;
  transition: background-color 0.3s ease;
}

.summary-button:hover {
  background-image:
    linear-gradient(120deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4)),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.summary-button:active {
  background-image:
    linear-gradient(120deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.summary-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 100%;
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;

  flex: 0 0 25%;
}

.right-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.inputText {
  margin-bottom: 10px;
}

.line {
  border-bottom: 1px solid #e4e4e4;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

/* .left-button {
  flex: 0 0 15%;
} */

.agree {
  display: flex;
  align-items: flex-start;
}

/* .radioClass {
  display: flex;
} */

.radioHorizontal {
  margin-right: 24px !important;
  color: rgba(0, 0, 0, 0.38);
  margin-bottom: 5px;
}

.description {
  color: #212121;
  font: 500 16px/130% "Outfit";
  margin-bottom: 10px;
  text-align: left;
  position: relative;
  align-self: stretch;
}

.brLine {
  margin-bottom: 18px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}
.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}
.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}
.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

@media (max-width: 700px) {
  .container:is(.Desktop, .Tablet) {
    flex-direction: column;
    gap: 14px;
  }

  .flex_dropdown:is(.Desktop, .Tablet),
  .flex_inputText:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .flex_half:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .buttoncontainer:is(.Desktop, .Tablet) {
    gap: 10px;
  }

  .left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
  }

  .right-button:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .right-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .summary-button:is(.Desktop, .Tablet) {
    flex: 0 0 100%;
  }

  .summary-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 100%;
  }

  .separator:is(.Desktop, .Tablet) {
    margin-bottom: 0;
  }
}

.mobile1:is(.Mobile) {
  width: 30%;
}

.mobile2:is(.Mobile) {
  width: 70%;
}

.separator .container {
  max-width: none;
}

.content:is(.Mobile) {
  padding: 0;
}

.progressContainer:is(.Mobile) {
  max-width: 1440px;
  margin: auto;
  padding: 0;
  background: #fff;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.container:is(.Mobile) {
  flex-direction: column;
  gap: 14px;
}

.flex_dropdown:is(.Mobile),
.flex_inputText:is(.Mobile) {
  width: 100%;
}
.flex_half:is(.Mobile) {
  width: 100%;
}

.buttoncontainer:is(.Mobile) {
  gap: 10px;
  margin-bottom: 24px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.right-button:disabled:is(.Mobile) {
  flex: 0 0 68%;
}

.summary-button:is(.Mobile) {
  flex: 0 0 100%;
}

.summary-button:disabled:is(.Mobile) {
  flex: 0 0 100%;
}

.separator:is(.Mobile) {
  margin-bottom: 0;
}

.margin:is(.Mobile) {
  margin-bottom: 10px;
}
</style>
